import { requester } from "App";
import Dummy from "components/Dummy";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import rank1Icon from "resources/img/puffu/rank1.png";
import rank2Icon from "resources/img/puffu/rank2.png";
import rank3Icon from "resources/img/puffu/rank3.png";
import btnSound from "resources/music/button-pressed-38129.mp3";
import categorySound from "resources/music/물방울.mp3";
import { useTouchClick } from "shared/hooks/useTouchClick";

import style from "./ProductCard3.module.css";
import { closeDropdown } from "../../process/category/SortingDropdownReducer";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";


function ProductCard3(props) {
    const { id } = useParams();
    const { isMobile } = useContext(BrowserDetectContext);
    const { data, vertical, key,index,currentProductIndex, setCurrentProductIndex} = props;
    const audioRef = useRef();
    const audio2Ref = useRef();
    const dispatch = useDispatch();
    const cartProducts = useSelector(state => state.cart.products);
    const cartRemainProducts = useSelector(state => state.cart.remainProducts);
    const cartProduct = cartProducts.find(product => product.id === data.id);
    const cartRemainProduct = cartRemainProducts ?  cartRemainProducts.find(product => product.id === data.id) : null;
    const cartQuantity = cartProduct ? cartProduct.quantity : 0;
    const cartRemainQuantity = cartRemainProduct ? cartRemainProduct.quantity : 0;
    const isAllStockAddedToCart = cartQuantity + cartRemainQuantity >= data.quantity;

    const onClickProduct = () => {
        if (audio2Ref.current) {
            audio2Ref.current.play().catch((error) => {
                console.error('오디오 재생 오류:', error);
            });
        }
        let reviewData = {
            productId: data.productId
        }
        requester.productReviewCount(reviewData, (result) => {
            if (result.code === 0) {
                props.setViewData((prevData) => ({
                    ...prevData,
                    detailYn: true,
                    detailProduct: data,
                    // view: props.filter ? props.filter : null,
                    reviewCount: result.data.count
                }));
                setCurrentProductIndex(index);
            }
        })
    };


    const addCartClick = () => {
        if (audioRef.current) {
            audioRef.current.play().catch((error) => {
                console.error('오디오 재생 오류:', error);
            });
        }
        let deviceCode = window.BRIDGE && window.BRIDGE.getDeviceCode() ? window.BRIDGE.getDeviceCode() : null;
        dispatch(CartReducer.actions.addProductToCart({ ...data, quantity: 1, originQuantity: data.quantity, deviceCode }));
        dispatch(closeDropdown());
    };

    const { handleTouchStart: productTouchStart, handleTouchEnd: productTouchEnd } = useTouchClick(onClickProduct, 50, (deltaX, deltaY) => {
    });
    const { handleTouchStart: cartTouchStart, handleTouchEnd: cartTouchEnd } = useTouchClick(addCartClick, 10);


    const getRankIcon = (rank) => {
        switch (rank) {
            case 1:
                return rank1Icon;
            case 2:
                return rank2Icon;
            case 3:
                return rank3Icon;
            default:
                return null;
        }
    }

    const rankIcon = props.filterProduct ? null : getRankIcon(data.productRank);

    return (
        <div
            style={{
                display: "flex",
                flex: props.flex ? props.flex : "1 0 20%",
                justifyContent: "center",
                alignItems: "center",
                // border: "1.5px solid #bbb",
                borderRadius: "3px",
                overflow: 'hidden'

            }}
        >
            <audio ref={audioRef} src={btnSound} preload="auto" />
            <div
                style={{
                    width: "100%",
                    position: "relative"
                }}
            >
                <div className={style.rankLabel} style={{ pointerEvents: 'none' }}>
                    <VerticalFlex width={"max-content"} gap={5}>
                        {
                            data.productRank !== null &&
                            <FlexChild>
                                <img src={rankIcon} width={"30px"} />
                            </FlexChild>
                        }

                        {
                            data.sales || data.productRank !== null
                                ?
                                <FlexChild>
                                    <div className={style.best}>
                                        <P color={"white"} size={12} font={"Pretendard"} weight={700}>BEST</P>
                                    </div>
                                </FlexChild>
                                :
                                null
                        }
                        {/* {
                            data.eventYn &&
                            <FlexChild>
                                <P>이벤트</P>
                            </FlexChild>
                        } */}
                        { }
                        {
                            data.newYn &&
                            <FlexChild>
                                <div className={style.new}>
                                    <P color={"white"} size={12} font={"Pretendard"} weight={700}>NEW</P>
                                </div>
                            </FlexChild>
                        }
                    </VerticalFlex>
                </div>



                <VerticalFlex gap={10}>
                    <FlexChild>
                        {/* <div style={{ border: "1.5px solid #bbb", }}> */}
                        <div className={style.productCard}>
                            <audio ref={audio2Ref} src={categorySound} preload="auto" />
                            <VerticalFlex>
                                {/* <FlexChild backgroundColor= {"white"} backgroundImage={data.productBgImg ? `url(${data.productBgImg})` : `url(${testProductBg})`} backgroundSize={"cover"}> */}
                                <FlexChild backgroundColor= {"white"} backgroundImage={data.productBgImg ? `url(${data.productBgImg})` : null } backgroundSize={"cover"}>
                                    {isAllStockAddedToCart && (
                                        <div style={{ pointerEvents: 'none' }} className={style.allStockAddedMessage} >
                                            <P color="white" size={18} font="Pretendard" weight={700}>모든 상품이 담겼어요</P>
                                        </div>
                                    )}
                                    <div
                                        style={{
                                            borderTopLeftRadius: "3px",
                                            borderTopRightRadius: "3px",

                                            padding: "5px",
                                            display: "flex",
                                            width: vertical ? "207px" : "auto",
                                            maxWidth: "207px",
                                            maxHeight: "207px",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            position: "relative"
                                        }}
                                        className={style.productCardImg}
                                        onPointerDown={productTouchStart}
                                        onPointerUp={productTouchEnd}
                                    >
                                        <img src={data.productImg} width={"max-content"} height={vertical ? "207px" : "207px"} />

                                    </div>
                                </FlexChild>
                                <FlexChild backgroundColor={"white"}>
                                    <Center width={"130px"}>
                                        <Dummy height={"10px"} />
                                        <P font={"Pretendard"} weight={700} ellipsis size={isMobile ? "1vw" : 15}>
                                            {data.productName}
                                        </P>
                                        <P font={"Pretendard"} weight={700} color={"var(--point-color)"} size={"1.2vw"}>
                                            {data.price ? data.price.toLocaleString() : '가격 없음'}원
                                        </P>
                                        <Dummy height={"5px"} />
                                    </Center>
                                </FlexChild>
                            </VerticalFlex>
                        </div>
                    </FlexChild>
                    {props.filter === 'exhibition' ? null : (
                        <FlexChild width={"100%"}>
                            <div
                                className={style.addCartButton}
                                onPointerDown={!isAllStockAddedToCart ? cartTouchStart : null}
                                onPointerUp={!isAllStockAddedToCart ? cartTouchEnd : null}
                                style={{
                                    opacity: isAllStockAddedToCart ? 0.5 : 1,
                                    pointerEvents: isAllStockAddedToCart ? 'none' : 'auto'
                                }}
                            >
                                <Center>
                                    <P
                                        size={24}
                                        width={"100%"}
                                        color={"white"}
                                        padding={"8px 15px"}
                                        cursor={"pointer"}
                                        font={"Pretendard"}
                                        weight={700}
                                    >
                                        상품 담기1
                                    </P>
                                </Center>
                            </div>
                        </FlexChild>
                    )}
                </VerticalFlex>
            </div>
        </div>
    );
};

export default ProductCard3;